import {useContext, useEffect, useMemo, useState} from "react";
import Marker from "./Marker";
import {MapContext} from "../context/MapContext";

const POP_WAVES = 3
const POP_WAVE_DELAY = 280
const POP_OUT_DURATION = 260

let markerInstanceId = 0

const getMarkerKey = ({element, index}) => `${element.type}-${element.index}-${index}`

const LocationsMarkers = ({locations}) => {
  const {searchFilter} = useContext(MapContext)
  const [renderedMarkers, setRenderedMarkers] = useState([])
  const visibleLocations = useMemo(() => locations?.filter(element => (
    element.name.toLowerCase().includes(searchFilter.toLowerCase())
  )) ?? [], [locations, searchFilter])
  const targetMarkers = useMemo(() => visibleLocations.flatMap((element) =>
    element.coords.map((item, index) => ({element, item, index}))
  ), [visibleLocations])

  useEffect(() => {
    setRenderedMarkers(currentMarkers => {
      const activeMarkers = currentMarkers.filter(marker => !marker.isLeaving)
      const activeMarkersByKey = new Map(activeMarkers.map(marker => [marker.key, marker]))
      const targetMarkerKeys = new Set(targetMarkers.map(getMarkerKey))
      const nextMarkers = targetMarkers.map((marker, position) => {
        const key = getMarkerKey(marker)
        const existingMarker = activeMarkersByKey.get(key)

        return {
          ...marker,
          key,
          instanceId: existingMarker?.instanceId ?? ++markerInstanceId,
          isLeaving: false,
          popDelay: (position % POP_WAVES) * POP_WAVE_DELAY,
        }
      })
      const leavingMarkers = activeMarkers
        .filter(marker => !targetMarkerKeys.has(marker.key))
        .map(marker => ({...marker, isLeaving: true}))

      return [...nextMarkers, ...leavingMarkers]
    })
  }, [targetMarkers])

  useEffect(() => {
    if (!renderedMarkers.some(marker => marker.isLeaving)) return

    const timeout = window.setTimeout(() => {
      setRenderedMarkers(currentMarkers => currentMarkers.filter(marker => !marker.isLeaving))
    }, POP_OUT_DURATION)

    return () => window.clearTimeout(timeout)
  }, [renderedMarkers])

  return renderedMarkers.map((marker) => (
    <Marker
      key={`${marker.key}-${marker.instanceId}`}
      element={marker.element}
      item={marker.item}
      animateOnLoad={!marker.isLeaving}
      isLeaving={marker.isLeaving}
      popDelay={marker.popDelay}
    />
  ))
}

export default LocationsMarkers;
